import React from "react";

import { ProductFeatureModel } from "@api/mappers/products.mapper";

import { Tooltip } from "@components/General/Tooltip/tooltip.component";
import { renderFeature } from "@components/Product/ProductTile/components/description/description.component";

import { FeatureKind } from "lib/@types/service/product/shared";

type FeatureProps = {
    feature: ProductFeatureModel;
    featureKind: FeatureKind;
};

const Feature = ({ feature, featureKind }: FeatureProps) => {
    return (
        <>
            <div className="col-12 feature-list-component__item">
                <div className="row border-bottom ">
                    <div className="col-6 feature-list-component__item--gray">
                        <div className="py-2">
                            {feature.name}
                            {feature.toolTipImage && (
                                <Tooltip title={featureKind.name}>
                                    <img
                                        className="mw-100"
                                        alt={feature.toolTipImage.altText || ""}
                                        src={feature.toolTipImage.url}
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </Tooltip>
                            )}
                        </div>
                    </div>
                    <div className="col-6 bg-light">
                        <div className="py-2">{renderFeature(feature)}</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { Feature };
